import { AfterViewInit, Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-intro-red',
  templateUrl: './intro-red.component.html',
  styleUrls: ['./intro-red.component.scss']
})
export class IntroRedComponent implements OnInit {

  image: string | undefined;
  content: string | undefined;

  ngOnInit(): void {
    ({ image: this.image, content: this.content } = this);
  }

  makeStyle() {
    return "background: url(http://localhost:8082/siep-cms/images/" + this.image + ") center no-repeat!important; height:480px; width:100%!important";
  }

}
